import {Domain_getItems} from "../PAdbUtils";
import * as AsyncLock from 'async-lock';
import {PAdbContext} from "../PAdbContext";
import * as _ from "lodash"

export class Language {

    private static dctLanguages: {[wbBusinessUnit:string]: string[]} = {}
    private static Lock = new AsyncLock({})
    private static dbContext: PAdbContext = undefined

    static getDbContext(): PAdbContext {
        if(_.isEmpty(Language.dbContext))
            Language.dbContext = new PAdbContext({bDisableTracking: true})
        return Language.dbContext
    }

    static async getLanguages(wbBusinessUnitId?: number, bSkipCache?: boolean): Promise<string[]> {

        let results = await Language.Lock.acquire<string[]>('global', async (done): Promise<void> => {
            let wbBUId = wbBusinessUnitId || 0

            if(wbBUId in Language.dctLanguages && !bSkipCache){
                done(undefined, Language.dctLanguages[wbBUId])
                return
            }
            let dbContext = Language.getDbContext()
            let items = await Domain_getItems(dbContext, ['Language'])
            items = _.sortBy(items, ['DOMAIN_ITEM_SORT','DOMAIN_ITEM_NAME'])
            let returnValue = _.map(items, (i) => i.cif.DOMAIN_ITEM_ID)
            if(_.isEmpty(returnValue))
                returnValue = ['en']
            Language.dctLanguages[wbBUId] = returnValue
            done(undefined, returnValue)
        })

        return results
    }
}

